import { ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalTitle } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ETestId } from '../../../common/constants';

interface IFilterModalContainerProps extends React.PropsWithChildren {
  title: string;
  contentTestId?: string;
  footerTestId?: string;
  hideFooter?: boolean;
  onResetClick(): void;
  onApplyClick(): void;
  onClose(): void;
}

export const FilterModal = React.forwardRef<HTMLDivElement, IFilterModalContainerProps>(
  ({ title, children, onResetClick, onApplyClick, onClose, hideFooter }, ref) => {
    return (
      <ModalContent>
        <div ref={ref}>
          <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
          </ModalHeader>

          <ModalBody>
            <div className={styles['content']} data-testid={ETestId.RedesignedFiltersPriceModalContent}>
              {children}
            </div>
          </ModalBody>

          <ModalFooter>
            {!hideFooter && (
              <div className={styles['controls']} data-testid={ETestId.RedesignedFiltersPriceModalFooter}>
                <Button theme="fill_secondary" onClick={onResetClick} fullWidth data-testid="filter-modal_reset">
                  Сбросить
                </Button>
                <Button theme="fill_primary" onClick={onApplyClick} fullWidth data-testid="filter-modal_apply">
                  Применить
                </Button>
              </div>
            )}
          </ModalFooter>
        </div>
      </ModalContent>
    );
  },
);

FilterModal.displayName = 'FilterModal';
